import styled, { css } from 'styled-components'

export const ManagementIntroWrapper = styled.div`
    .gridItem {
        width: calc(50% - 8px);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding: 32px;

        h1 {
            font-size: 24px;
            font-weight: 700;
            white-space: pre-wrap;
            @media only screen and (max-width: 1200px) {
                font-size: 20px;
            }
            @media only screen and (max-width: 767px) {
                font-size: 20px;
            }
        }

        h2 {
            font-size: 16px;
            font-weight: 500;
            @media only screen and (max-width: 320px) {
                font-size: 14px;
            }
        }
        
        @media only screen and (max-width: 320px) {
            padding: 16px;
        }
    }

    .active {
        background: #00B74F;

        h1 {
            color: #ffffff;
        }

        h2 {
            color: #ffffff;
        }
    }

    .inActive {
        box-shadow: 7px 4px 6px -3px #00000059;
        background: #F2F2F2;

        &:hover {
            box-shadow: 7px 4px 6px -1px #00000065;
        }

        h1 {
            color: #575757;
        }

        h2 {
            color: #575757;
        }
    }

    .content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
`
export const LeftShadowBox = styled.div`
    box-shadow: 7px 4px 6px -3px #00000059;
    background: #F2F2F2;
    padding: 32px 40px;
    height: 100%;
    @media only screen and (max-width: 1200px) {
        padding: 16px;
    }
    @media only screen and (max-width: 768px) {
        padding: 16px;
        margin: 0 16px;
    }
`
export const ManageLeftTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #575757;
  white-space: pre-wrap;
  @media only screen and (max-width: 1200px) {
    font-size: 24px;
  }
  @media only screen and (max-width: 767px) {
    font-size: 24px;
  }
`
export const ManageLeftDesc = styled.div`
  font-size: 18px;
  font-weight: 500;
  text-align: justify;
  color: #575757;
  padding: 16px 0;
  @media only screen and (max-width: 1200px) {
    font-size: 16px;
  }
  @media only screen and (max-width: 767px) {
    font-size: 16px;
  }
`
export const ManagementItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`
export const ManagementItemNumber = styled.div`
  background: #00B74F;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  padding: 16px 24px;
  @media only screen and (max-width: 1200px) {
    font-size: 24px;
    padding: 12px 18px;
  }
`
export const ManagementItemText = styled.span`
  font-size: 18px;
  font-weight: 500;
  text-align: justify;
  color: #575757;
  @media only screen and (max-width: 1200px) {
    font-size: 16px;
  }
`
export const ManagementGrid = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  height: 100%;
    @media only screen and (max-width: 1200px) {
        padding: 16px;
    }
    @media only screen and (max-width: 768px) {
        padding: 16px;
    }
    @media only screen and (max-width: 375px) {
        padding: 4px;
    }    
`
export const ManagementGridTitle = styled.h1`
    box-sizing: border-box;
    max-width: 100%;
    overflow-wrap: break-word;
    @media only screen and (max-width: 320px) {
        font-size: 14px !important;
    }
`